import rest from '@modules/rest'
import { mapForeignInput } from '@convenia/employee-organisms/SystemFields/Personal/content/mappers/foreign'

export const getForeign = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/foreign/admission`

    const { data } = await rest.get(url)

    return [ null, data ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateForeign = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/foreign/admission`
    const body = mapForeignInput({ data, schema })

    const response = await rest.post(url, { body })

    return [ null, response?.data ]
  } catch (err) {
    return [ err, null ]
  }
}
